/* eslint-disable @typescript-eslint/naming-convention */
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { GroupOrderAnalyticsPayload } from "@swiggy-private/cart-types";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionGroupCartPage = (
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
    props: GroupOrderAnalyticsPayload,
): void => {
    screenViewEvent({
        category: SCREEN_NAME.GROUP_CART,
        context: JSON.stringify({ rx_id: props.restId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_GROUP_CART,
        extraParams: JSON.stringify({ grp_cart_id: props.groupCartId, is_initiator: props.isInitiator }),
        label: "intermediate-grp-cart",
    });
};

export const clickGroupCartItem = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    label: string,
    payload: GroupOrderAnalyticsPayload,
): void => {
    clickEvent({
        category: SCREEN_NAME.GROUP_CART,
        context: JSON.stringify({ rx_id: payload.restId }),
        action: CLICK_ACTIONS.CLICK_GROUP_CART_ITEM,
        extraParams: JSON.stringify({ grp_cart_id: payload.groupCartId, is_initiator: payload.isInitiator }),
        label: label,
    });
};

export const impressionGroupCartItem = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    payload: {
        type: string;
        groupCartId: string;
        position: number;
        isInitiator: boolean;
        restId: string;
        userId: string;
        itemIds?: string[];
    },
): void => {
    impressionEvent({
        category: SCREEN_NAME.GROUP_CART,
        context: JSON.stringify({ rx_id: payload.restId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_GROUP_CART_ITEM,
        extraParams: JSON.stringify({
            position: payload.position,
            grp_cart_id: payload.groupCartId,
            is_initiator: payload.isInitiator,
            user_id: payload.userId,
            items: payload?.itemIds,
        }),
        label: payload.type,
    });
};

export const clickUpdateItemQuantity = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    payload: {
        type: string;
        position: number;
        groupCartId: string;
        isInitiator: boolean;
        restId: string;
        userId: string;
    },
): void => {
    clickEvent({
        category: SCREEN_NAME.GROUP_CART,
        context: JSON.stringify({ rx_id: payload.restId }),
        action: CLICK_ACTIONS.CLICK_GROUP_CART_ITEM,
        extraParams: JSON.stringify({
            position: payload.position,
            grp_cart_id: payload.groupCartId,
            is_initiator: payload.isInitiator,
            user_id: payload.userId,
        }),
        label: payload.type,
    });
};

export const clickGroupCartCheckoutcta = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    props: GroupOrderAnalyticsPayload,
): void => {
    clickEvent({
        category: SCREEN_NAME.GROUP_CART,
        context: JSON.stringify({ rx_id: props.restId }),
        action: CLICK_ACTIONS.CLICK_GROUP_CHECKOUT_CTA,
        extraParams: JSON.stringify({ grp_cart_id: props.groupCartId, is_initiator: props.isInitiator }),
    });
};

export const impressionGroupCartCheckoutcta = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    props: GroupOrderAnalyticsPayload,
): void => {
    impressionEvent({
        category: SCREEN_NAME.GROUP_CART,
        context: JSON.stringify({ rx_id: props.restId }),
        action: IMPRESSION_ACTIONS.IMPRESSION_GROUP_CHECKOUT_CTA,
        extraParams: JSON.stringify({ grp_cart_id: props.groupCartId, is_initiator: props.isInitiator }),
    });
};
